import { request, AUTH_HEADER } from '../utils/Api';

export function fetchSearchResults(searchQuery, guid) {
  return dispatch => {
    // Request data for initial state (startup endpoint)
    return new Promise((resolve, reject) => {
      request('', 'GET', { 'endpoint': 'search', 'query': searchQuery, 'guid': guid }).then((response) => {
        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }
}

export function openSearch() {
  return dispatch => {
    dispatch({
      type: "OPEN_SEARCH",
    });
  }
}

export function closeSearch() {
  return dispatch => {
    dispatch({
      type: "CLOSE_SEARCH",
    });
  }
}

export function clearSearch() {
  return dispatch => {
    dispatch({
      type: "CLEAR_SEARCH",
    });
  }
}

export function updateSearchQuery(query) {
  return dispatch => {
    dispatch({
      type: "UPDATE_SEARCH_QUERY",
      payload: query
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/search.js